import React, { ReactNode } from 'react';
import { OptimizelyProvider } from '@optimizely/react-sdk';

import { useOpalUser } from '@frontend/hooks';

import { optimizelyClient } from './optimizelyClient';

type FeatureFlagProviderProps = {
  children: ReactNode;
};

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({ children }) => {
  const { opalUser } = useOpalUser();
  const emailDomain =
    opalUser?.email && opalUser.email.includes('@')
      ? (opalUser.email.split('@').pop() ?? null)
      : null;
  return (
    <OptimizelyProvider
      optimizely={optimizelyClient}
      user={{
        id: opalUser?.id,
        attributes: {
          email: opalUser?.email,
          emailDomain,
          isVau: opalUser?.is_vau ?? null,
          turnstileUserId: opalUser?.id,
          instanceId: opalUser?.instance.instance_id,
          customerId: opalUser?.instance.customer_id,
          productSku: opalUser?.instance.product_sku,
          productId: opalUser?.instance.product_id,
        },
      }}
    >
      {children}
    </OptimizelyProvider>
  );
};
